/**
 * @module lib/native
 * Provide interfaces for interacting with the native client container.
 * Relies on APIs exposed by the native client.
 */


import logger from "lib/log";

/**
 * Ofcom fictional number: 07700900827
 * https://www.ofcom.org.uk/phones-telecoms-and-internet/information-for-industry/numbering/numbers-for-drama
 * T9: 8(T) 2(2) 7(P)
 *
 * The native client recognises this and allows the user to skip verification.
 * When we detect it, we serve sample data locally instead of fetching from appserver.
 */
export const DEBUG_MOBILE_NUMBER = "+447700900827";


// This needs to match the platform strings in userIdentity
const PLATFORM = {
  ANDROID : "android",
  IPHONE : "iphone",
}

export function openURL(platform, url) {
  switch (platform) {
    case PLATFORM.ANDROID:
      window.android.openURL(url);
      break;
    case PLATFORM.IPHONE:
      window.webkit.messageHandlers.openUrlHandler.postMessage(url);
      break;
    // Browser actions for debugging only
    default:
      window.location.href = url;
      break;
  }
}

export function openEmail(platform, email) {
  switch (platform) {
    case PLATFORM.ANDROID:
      window.android.openEmail(email);
      break;
    case PLATFORM.IPHONE:
      window.webkit.messageHandlers.openEmailHandler.postMessage(email);
      break;
    default:
      break;
  }
}


export function openPhone(platform, phoneNumber) {
  switch (platform) {
    case PLATFORM.ANDROID:
      window.android.openPhoneNumber(phoneNumber);
      break;
    case PLATFORM.IPHONE:
      window.webkit.messageHandlers.diallerHandler.postMessage(phoneNumber);
      break;
    default:
      break;
  }
}


export function forceRegistration(platform, alertMessage) {
  switch (platform) {
    case PLATFORM.ANDROID:
      window.android.forceRegistration(alertMessage);
      break;
    case PLATFORM.IPHONE:
      window.webkit.messageHandlers.forceRegistrationHandler.postMessage(alertMessage);
      break;
    default:
      break;
  }
}

// ANDROID ONLY API
export function closeApplication(platform) {
  switch (platform) {
    case PLATFORM.ANDROID:
      window.android.closeApplication();
      break;
    default:
      logger.warn(`lib/native/closeApplication is not compatible with platform "${platform}", ignoring...`);
      break;
  }
}



// WEBPACK FOOTER //
// ./src/lib/native/index.js